// src/amplify.ts
import { Amplify } from "aws-amplify";
import { cognito } from "./cognito";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: cognito.userPoolId,
      userPoolClientId: cognito.userPoolClientId,
      loginWith: {
        oauth: {
          domain: cognito.domain,
          scopes: cognito.scopes,
          redirectSignIn: [cognito.redirectSignIn],
          redirectSignOut: [cognito.redirectSignOut],
          responseType: "code",
        },
      },
    },
  },
});
